import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Section from "../Section/Section";
import PillsGroupSkeleton from "../PillsGroup/PillsGroupSkeleton";
import styles from "./EventSummary.module.css";

const EventSummarySkeleton: React.FC = () => {
  return (
    <Section>
      <Skeleton
        variant="text"
        width="80%"
        height={40}
        className={styles["title"]}
      />
      <PillsGroupSkeleton count={4} showIcon showLabel />
    </Section>
  );
};

export default EventSummarySkeleton;
